import { BarChart3, Building2, CalendarDays, Handshake, Heart, MapPin, Ticket, User, Users, Wallet } from "lucide-react";
import { useI18n } from "@/i18n/I18nProvider";
import { useDialogs } from "@/lib/dialogs";

const STEPS = [
  [User, "Onboard & Verify", "Choose company or freelancer, state, language and subscription.", ["onboard"]],
  [Users, "Discover & Connect", "Join the network of planners, venues and service partners.", ["partner", { kind: "Partner" }]],
  [CalendarDays, "Plan & Collaborate", "Open the existing Event 360, Event Graph and EventThreads.", ["launcher"]],
  [Wallet, "Transact & Track", "Launch the existing ERP, sourcing and finance workflows.", ["launcher"]],
  [BarChart3, "Deliver & Grow", "Use existing reporting and operations to improve performance.", ["launcher"]],
];

const QUICK = [
  ["wedding", Heart, "Wedding", "New inquiry", ["inquiry", { prefill: { type: "Wedding" } }]],
  ["corporate", Building2, "Corporate", "Event request", ["inquiry", { prefill: { type: "Corporate" } }]],
  ["social", Ticket, "Social Event", "Celebration", ["inquiry", { prefill: { type: "Social" } }]],
  ["venue", MapPin, "Venue", "Partner inquiry", ["partner", { kind: "Venue" }]],
  ["referral", Handshake, "Referral", "Join network", ["partner", { kind: "Partner" }]],
];

export const Workflow = () => {
  const { t } = useI18n();
  const open = useDialogs();
  return (
    <div className="lower-grid">
      <section className="panel" id="workflow" data-testid="workflow-section">
        <h2 className="panel-title">{t("workflow_title")} <span className="tag graytag">PORTAL + EXISTING OPERATIONS</span></h2>
        <div className="flowline">
          {STEPS.map(([Icon, title, text, action], i) => (
            <button key={title} className="flowstep" onClick={() => open(...action)} data-testid={`workflow-step-${i + 1}`}>
              <div className="step-num">{i + 1}</div><Icon className="ic lg" /><b>{title}</b><p>{text}</p>
            </button>
          ))}
        </div>
      </section>
      <section className="panel" data-testid="quick-access-section">
        <h2 className="panel-title">{t("quick_title")}</h2>
        <div className="quick-grid">
          {QUICK.map(([key, Icon, title, sub, action]) => (
            <button key={key} className="quick" onClick={() => open(...action)} data-testid={`quick-${key}-button`}>
              <Icon className="ic" /><b>{title}</b><span>{sub}</span>
            </button>
          ))}
        </div>
      </section>
    </div>
  );
};
